import { alpha, styled } from "@mui/material";
import * as ModalSlideUpStyled from "./ModalSlideUp.styled";

export const ModalDialogTitleStack = styled(ModalSlideUpStyled.ModalDialogTitleStack)(({ theme }) => ({
    boxShadow: `0 4px 8px 0 ${alpha(theme.palette.common.black, 0.1)}`,
}));
